import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const StarIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      d="M7.73103 1.87833C7.84108 1.65538 8.159 1.65538 8.26905 1.87833L9.99031 5.3654C10.034 5.45386 10.1183 5.5152 10.2159 5.52946L14.0656 6.09215C14.3115 6.1281 14.4096 6.43045 14.2315 6.6039L11.4464 9.31658C11.3756 9.3855 11.3433 9.48484 11.36 9.5822L12.0173 13.4141C12.0593 13.6592 11.802 13.8461 11.582 13.7304L8.13968 11.9201C8.05226 11.8741 7.94782 11.8741 7.8604 11.9201L4.41813 13.7304C4.19804 13.8461 3.94078 13.6592 3.98281 13.4141L4.64003 9.5822C4.65673 9.48484 4.62443 9.3855 4.55367 9.31658L1.76858 6.6039C1.5905 6.43045 1.68853 6.1281 1.93451 6.09215L5.78415 5.52946C5.88176 5.5152 5.96611 5.45386 6.00977 5.3654L7.73103 1.87833Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
));
